import React from 'react';
import ISA315ItControlTestingItem from './ISA315ItControlTestingItem';

function ISA315ItControlTesting({itControl, engagementId, setIsLoading}) {
	return <ISA315ItControlTestingItem itControl={itControl} engagementId={engagementId} setIsLoading={setIsLoading} />;
}

export default ISA315ItControlTesting;
